<div class="table-container">
    <table mat-table [dataSource]="tableData" (keyup)="onKeyup($event)">
        <ng-container matColumnDef="title">

            <!-- Top Header Line -->
            <th-text *matHeaderCellDef
                     [colspan]="colspan"
                     [colIndex]="0"
                     [strong]="true">{{tableHeaders.title}}</th-text>

            <ng-container *matCellDef="let element; let rowIndex = index">
                <!-- Total Header Line -->
                <th-text [colspan]="colspan"
                         [colIndex]="0"
                         [emphasis]="true"
                         *ngIf="element.type | isRowType:tableRowType.totalHeader">{{element.title}}</th-text>
                <!-- Chapter Header Line-->
                <th-text [colspan]="colspan"
                         [colIndex]="0"
                         [collapser]="true"
                         *ngIf="element.type | isRowType:tableRowType.chapterHeader"
                         (onCollapse)="collapse(element.chapterType, $event)">{{element.title}}</th-text>
                <!-- Block Content Lines -->
                <cost-grid-block-content *ngIf="element.type | isRowType:tableRowType.blockData"
                                         [focusCoord]="focusCoordsFromKeyboard"
                                         [rowIndex]="rowIndexSubtract[rowIndex]"
                                         [element]="element"
                                         [beginDate]="quotation.begin"
                                         [costBlockCategoryConfig]="costBlockCategoryConfiguration"
                                         [suppliers]="suppliers"
                                         [defaultCurrencies]="defaultCurrencies"
                                         [quotationCurrency]="quotationCurrency"
                                         [isEditable]="element | isEditableCell:quotation:hasPermissionToEdit"
                                         [isEmpty]="element.block.isEmpty"
                                         (emptyAndFocus)="emptyAndFocus($event)"
                                         (onAddBlockPlaceholder)="addPlaceholderAfter(element, rowIndexSubtract[rowIndex])"
                                         (onFocusField)="emitFocusChange($event)"
                                         (onValueChange)="emitCellChange($event, element.block.id)"
                                         (onMoveModeChange)="onMoveModeChange($event)"
                                         (onSearchSuppliers)="onSearchSuppliers($event)">
                </cost-grid-block-content>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="total">
            <th-text *matHeaderCellDef
                     [colIndex]="1"
                     [strong]="true"
                     [isSticky]="true"
                     [colspan]="totalColspan"><strong>{{tableHeaders.total}}</strong></th-text>

            <ng-container *matCellDef="let element; let rowIndex = index; let oddA = odd">
                <th-price *ngIf="element.type | isRowType: tableRowType.totalHeader"
                          [price]="element.total"
                          [isSticky]="true"
                          [parity]="oddA ? 'odd' : 'even'"
                          [colspan]="totalColspan"></th-price>

                <th-text [colIndex]="1"
                         [colspan]="chapterColspan"
                         *ngIf="element.type | isRowType: tableRowType.chapterHeader"></th-text>

                <cost-grid-block-value *ngIf="element.type | isRowType: tableRowType.blockData"
                                       [total]="element.block | extractCost"
                                       [rowIndex]="rowIndexSubtract[rowIndex]"
                                       [focusCoordsFromKeyboard]="focusCoordsFromKeyboard"
                                       [quotationCurrency]="quotationCurrency"
                                       [isEditable]="element | isEditableCell:quotation:hasPermissionToEdit"
                                       [isEmpty]="element.block.isEmpty"
                                       [supplier]="element.block.supplier"
                                       [defaultCurrencies]="defaultCurrencies"
                                       [parity]="oddA ? 'odd' : 'even'"
                                       [currencyXRates]="quotation.details?.xrates"
                                       (onMoveModeChange)="onMoveModeChange($event)"
                                       (emptyAndFocus)="emptyAndFocus($event)"
                                       (onCostChange)="emitCellChange($event, element.block.id)"
                                       (onCurrencyChange)="emitCellChange($event, element.block.id)"
                                       (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex: $event})"
                                       minWidth="70px"></cost-grid-block-value>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="travellers">
            <ng-container *matHeaderCellDef>
                <th-traveller [traveller]="traveller"
                              [index]="travellerIndex"
                              *ngFor="let traveller of tableHeaders.travellers; let travellerIndex = index"></th-traveller>
            </ng-container>
            <ng-container *matCellDef="let element; let rowIndex = index; let oddB = odd">
                <ng-container *ngIf="element.type | isRowType: tableRowType.totalHeader">
                    <th-price *ngFor="let traveller of element.travellers; trackBy: trackTraveller"
                              [price]="traveller.cost"></th-price>
                </ng-container>

                <ng-container *ngIf="element.type | isRowType: tableRowType.blockData">
                    <cell-price
                            *ngFor="let traveller of element.travellers; let colIndex = index; trackBy: trackTraveller"
                            [price]="element.block | extractTravellerDetailCost:traveller.id"
                            [isEditable]="element | isEditableCell:quotation:hasPermissionToEdit"
                            [canHaveFooter]="true"
                            [parity]="oddB ? 'odd' : 'even'"
                            [quotationCurrency]="quotationCurrency"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord: rowIndexSubtract[rowIndex]:colIndex + 3 "
                            [currencyXRates]="quotation.details?.xrates"
                            (onPriceChange)="emitTravellerDetailPriceChange($event,traveller.id, element.block)"
                            (onFocusField)="emitFocusChange({rowIndex : rowIndexSubtract[rowIndex], colIndex: colIndex + 3})"
                            (onMoveModeChange)="onMoveModeChange($event)">
                    </cell-price>
                </ng-container>

            </ng-container>
        </ng-container>

        <ng-container matColumnDef="end">
            <th-end *matHeaderCellDef></th-end>
            <td-end *matCellDef></td-end>
        </ng-container>

        <tr id="table-head" class="header-table-sticky" mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index; "
            [class.header-table-sticky]="i === 0"
            [class.isEditable]="isEditableCell(row)"
            [attr.id]="'row' + i"
            [hidden]="isBlock(row.type) && !areVisibleBlocks[row.chapterType]"></tr>
    </table>
</div>
